/**
 * Feature switches the server sends in `GET /api/platform/constants`.
 *
 * `feature.inventory_enabled` mirrors the `INVENTORY_ENABLED` switch (schema
 * doc 9.11). It defaults to false: only a real boolean `true` opens anything,
 * so a missing key, a failed read or a stringly value keeps Inventory hidden.
 * The printer flow itself has no switch (owner 2026-10-23): always on.
 *
 * Hiding is usability only — the server also refuses inventory routes while
 * the switch is off. Pure, so it is tested directly.
 */

export const INVENTORY_ENABLED_CONSTANT_KEY = "feature.inventory_enabled";

type ConstantsMap = Readonly<Record<string, unknown>>;

export function isInventoryEnabled(constants: ConstantsMap): boolean {
  return constants[INVENTORY_ENABLED_CONSTANT_KEY] === true;
}

/** Which switch an entry point (nav entry, route) waits on. */
export type FeatureGate = "inventory";

export interface FeatureFlags {
  inventory: boolean;
}

export function featureGateOpen(gate: FeatureGate | undefined, flags: FeatureFlags): boolean {
  if (!gate) return true;
  return flags.inventory;
}
